import React from 'react'
import PropTypes from 'prop-types'

import { Card, List } from 'semantic-ui-react'

import CardProperty from 'Components/CardProperty'

import { getFormattedDateString } from 'Global/Helpers/timeHelpers'

const FAEventCardInformation = ({ event }) => {
  return (
    <Card.Content extra>
      <List>
        <CardProperty icon="marker" popUpContent="Location">
          {event.location}
        </CardProperty>

        <CardProperty icon="calendar" popUpContent="Dates">
          {`${getFormattedDateString(event.dateStart)} – ${getFormattedDateString(event.dateEnd)}`}
        </CardProperty>
      </List>
    </Card.Content>
  )
}

FAEventCardInformation.propTypes = {
  event: PropTypes.object.isRequired,
}

export default FAEventCardInformation
